import { CHECKOUT_BOUYGUES_IN_STORE } from './flows/bouygues-in-store/route-names'
import { CHECKOUT_E_COMMERCE } from './flows/e-commerce/route-names'
import { CHECKOUT_GIFT_CARDS } from './flows/gift-card/route-names'

export { CHECKOUT_E_COMMERCE, CHECKOUT_BOUYGUES_IN_STORE, CHECKOUT_GIFT_CARDS }

// Maintain backward compatibility with existing CHECKOUT import
export const CHECKOUT = {
  ...CHECKOUT_E_COMMERCE,
  IN_STORE_SALES: CHECKOUT_BOUYGUES_IN_STORE,
  GIFT_CARDS: CHECKOUT_GIFT_CARDS,
}
